import type {ReactAction} from '@netx/core/bootstrap';
import {faUndoAlt} from '@fortawesome/pro-solid-svg-icons';
import {canResyncCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Resync cart assets
 * @param params
 * @returns Action
 */
export const cartActionResync = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-resync',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.RESYNC),
	enableTest: canResyncCurrentCart,
	icon: faUndoAlt,
	get label() {
		return CART_CURRENT_ACTION_LABELS.RESYNC;
	},
	...params,
});

export default cartActionResync;
